import { issuerService } from "../services/issuers.service";
import { issuerConstants, namespace, cardProgramsConstants, card_programs_nameSpace } from "../constants/issuers.constants";
import { cardSearchService } from "../../CardSearch/services/cardSearch.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";

export const getSCPIssuers = (isScpLite) => {
    return async (dispatch) => {
        dispatch(request());
        try {
            // const response = await issuerService.getSCPIssuers();
            
            if(isScpLite){
              
              const response = await issuerService.getSCPIssuers();
              response && dispatch(success(response));
            }else{
              const response = await issuerService.getPostCardIssuers();
              response && dispatch(success(response));
            }
           
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function request() {
        return { type: issuerConstants[`GET_${namespace}_REQUEST`] };
    }
    function success(response) {
        return { type: issuerConstants[`GET_${namespace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: issuerConstants[`GET_${namespace}_FAILURE`], error };
    }
};

export const getCardPrograms = (issuerNumber) => {
    return async (dispatch) => {
        dispatch(resetCardPrograms());
        dispatch(request());
        try {
            const response = await cardSearchService.getCardProgramsFromIssuer(issuerNumber);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get selected Issuer's card programs", error ? error.message : message.GENERIC_ERROR));
        }
    };
    function request(request) {
        return { type: cardProgramsConstants[`GET_${card_programs_nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return {
            type: cardProgramsConstants[`GET_${card_programs_nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: cardProgramsConstants[`GET_${card_programs_nameSpace}_FAILURE`], error };
    }
};

export const resetCardPrograms = () => {
    return { type: cardProgramsConstants[`GET_${card_programs_nameSpace}_RESET`] };
};
